<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/index/keyOrder"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>一键下单</div>
		<div></div>
	</header>
	<div class="z-body z-body-bottom">
		<!-- 列表表头 -->
	    <div class="z-keyOrderDown-Hq-list-th z-flex">
	    	<div>名称</div>
	    	<div>价格</div>
	    	<div>选择</div>
	    </div>
	    <!-- 列表数据 -->
	    <div class="z-keyOrderDown-Hq-list z-flex">
    		<template v-for="(item,index) in list">
    			<div class="z-flex z-keyOrderDown-Hq-list-a" @click="select(item)">
    				<div class="dark-color" v-text="item.title"></div>
    				<div>
    					<span style="color:#70757D;font-size:12px;" v-text="item.price"></span>
    				</div>
    				<div class="z-subAccount-state">
						<img src="../../assets/index/sub-account/yes.png" class="z-icon" v-if="cur_symbol == item.symbol">
					</div>
    			</div>
    		</template>
	    </div>
	</div>

	<!-- 弹出砍认框 -->
      <v-dialog v-model="dialog.show" max-width="290">
        <v-card light>
          <v-card-title class="headline">{{dialog.title}}</v-card-title>
          <v-card-text>{{dialog.content}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click="dialogCancel">取消</v-btn>
            <v-btn color="green darken-1" flat="flat" @click="dialogSuccess">同意</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

	<!-- 请选择购买类型 -->
      <v-dialog v-model="buyModelDialog" scrollable max-width="300px">
        <div class="z-keyOrderDown-buy-dialog">
          <div>请选择购买类型</div>
          <div :class="buyModel==1?'z-buy-model-select':''" @click="selectBuyModel(1)">
            市价
            <img v-if="buyModel==1" src="../../assets/index/sub-account/yes.png" class="z-icon" />
          </div>
          <div :class="buyModel==2?'z-buy-model-select':''" @click="selectBuyModel(2)">
            委托价
            <img v-if="buyModel==2" src="../../assets/index/sub-account/yes.png" class="z-icon" />
          </div>
          <div @click="buyModelDialog=false">取消</div>
        </div>
      </v-dialog>

	<div class="z-keyOrderDown-bottom">
      <!-- 选择 -->
      <div class="z-keyOrderDown-buy-select">
        <div>
          <input v-show="buyModel==1" type="number" v-model="last_price" placeholder="请输入市价" readonly="">
          <img v-show="buyModel==2" src="../../assets/kline/jian.png" style="margin-right:10px;" @click="price2Calc(0)">
          <input v-show="buyModel==2" type="number" v-model="price2" placeholder="请输入委托价">
          <img v-show="buyModel==2" src="../../assets/kline/jia.png" @click="price2Calc(1)">
        </div>
        <div @click="buyModelDialog=true">
          <span v-show="buyModel==1">市价</span>
          <span v-show="buyModel==2">委托价</span>
          <img src="../../assets/kline/drop-down.png">
        </div>
      </div>
      <!-- 按钮 -->
      <div class="z-keyOrderDown-btns">
        <div @click="buy(1)">买涨</div>
        <div @click="buy(2)">买跌</div>
      </div>

    </div>
</div>
</template>

<script>
export default {
	name: 'keyOrder',
	data() {
		return {
			list:[],
			symbols:[],
			cur_symbol:'',
			eventInterval:null,
			selectIn:[],
			// 购买弹框
	        dialog: {
	          show: false, //显示关态
	          type: null, //弹出类型
	          title: "你确定嘛",
	          content: "弹出说明文本.",
	          resolve: null, //创建的promise resolve函数
	          reject: null, //创建的promise reject
	          isConfirm: false //当前点击按钮类型 false为取消 true为确认
	        },
	        //当前合约ID
	        fid:0,
	        //合约名
	        stockName: "",
			//最新价
			last_price: 0,
			//购买类型弹框
	        buyModelDialog: false,
	        //购买类型：1市价  2委托价
	        buyModel: 1,
	        //购买方式：买涨  买跌
	        buyType: 1,
	        //市价
	        price1: '',
	        //委托价
	        price2: '',
	        price2Step: 0,
	        //用户ID集
	        uids:'',
		}
	},
	inject:['reload'],
	watch:{
		// 'last_price': function(newV) {
	 //        this.price2 = newV
	 //    },
		'$store.state.webscoketObj.readyState':function (newV) { //监听长连接状态
			let _this = this
			_this.colseEvent = setTimeout(function () {
				_this.reload()
			},1500)
		},
	},
	created() {
		this.uids = this.$route.query.uids

		this.init()

	},
	methods: {
		init(){
			let _this = this
			_this.get('api/Futures/index',{page:1}).then((res)=>{
				let list = res.data.list
				for(var i=0;i<list.length;i++){
					if (list[i].main==1) {
						if (i==0) {
							_this.select(list[i])
						}
						_this.symbols.push(list[i].symbol)
						_this.list.push(list[i])
					}
				}
				//长连接 - 检测和接收数据
				_this.wsCheck()
			})
		},
		wsCheck(){ //长连接 - 检测状态后数据接收
			let _this = this;
			//长连接状态正常才发送
			if (_this.$store.state.webscoketObj && _this.$store.state.webscoketObj.readyState==1) {
				clearInterval(_this.eventInterval)
				_this.$create_wsConfig(_this,_this.symbols.join(','),_this.getToken(),0)
				_this.$store.state.webscoketObj.onmessage = _this.processData
			}
			else { //长连接状态不正常，则轮询
				_this.eventInterval = setInterval(function () {
					clearInterval(_this.eventInterval)
					_this.wsCheck()
				},1000)
			}
		},
		processData(e) {
			let _this = this
			var rs = JSON.parse(e.data);
			if (rs.type=='hangqing') {
				let data = rs.data[0];
				let list = _this.list;
				for(let i=0;i<list.length;i++){
					let item = list[i];
					if (item.id==data.fid) {
						// console.log('keyOrderDown--页面 fid='+data.fid+'  last_price='+data.last_price)
						_this.list[i]['price'] = data.last_price
						if (data.fid == _this.fid) {
							_this.last_price = data.last_price
						}
						break;
					}
				}
			}
		},
		//委托价 加/减
      price2Calc(type) {
        let _this = this,
          s = _this.price2Step,
          o = _this.price2,
          n = type ? _this.zmath.add(o, s) : _this.zmath.sub(o, s);
        if (n < 0) {
          _this.$store.commit('layer', '委托价不能低于0')
        }
        _this.price2 = n
      },
      //获取委托 加/减 步长
      getPrice2CalcStep(fid) {
        this.get('api/Futures/variable_price', {
          id: fid
        }).then((rs) => {
          this.price2Step = parseFloat(rs.data)
        })
      },
      // 选择价格类型
      selectBuyModel(type) {
        if (type == 2) {
          this.price2 = this.last_price
        }
        this.buyModel = type
        this.buyModelDialog = false
      },
      // 买涨(做多1) / 买跌(做空2)
      buy(mp) {
        let price = this.last_price
        if (this.buyModel == 2) {
          price = this.price2

          if (!this.price2) {
            this.$store.commit('layer', '请输入委托价')
            return false
          }
        }
        this.showDialog(this.dialogOpt(mp, price)).then(() => {
          this.is_submit_ing = 1

          this.post('api/user_bind/DownOrder', {
            fid: this.fid,
            btype: this.buyModel, //1:市价 2委托价
            price: price,
            mp: mp,
            uids:this.uids

          }).then((res) => {
            this.is_submit_ing = 0
            this.$store.commit('layer', res.msg)
          })
        }).catch(() => {
          this.is_submit_ing = 0
        });
      },
      //显示弹出框
      dialogOpt(type, price) {
        let typeText = ""
        if (type == 1) {
          typeText = '买涨'
        } else if (type == 2) {
          typeText = '买跌'
        }
        price = price || '';
        let content = typeText + ': ' + this.stockName + '1手 ' + price;
        return {
          title: "确定交易?",
          content: content
        }
      },
      showDialog(opts) {
        return new Promise((resolve, reject) => {
          this.dialog.show = true;
          this.dialog.title = opts.title;
          this.dialog.content = opts.content;
          this.dialog.resolve = resolve;
          this.dialog.reject = reject;
        });
      },
      closeDialog() {
        //重置
        this.dialog.show = false;
        this.dialog.title = null;
        this.dialog.content = null;
        this.dialog.resolve = null;
        this.dialog.reject = null;
      },
      dialogSuccess() {
        this.dialog.resolve();
        this.closeDialog();
      },
      dialogCancel() {
        this.dialog.reject();
        this.closeDialog();
      },
      onShowMore() {
        this.isShowMore = !this.isShowMore
      },
		select(item){
			this.cur_symbol = item.symbol
			this.stockName = item.title
			this.getPrice2CalcStep(item.id)
			this.fid = item.id
			this.last_price = item.price
            this.price2 = item.price
		},

		// merger(){
		// 	this.post('api/UserAccount/merger',{}).then((rs)=>{
		// 		this.$store.commit('layer',rs.msg)
		// 		if (rs.code==0) {
		// 			this.init()
		// 		}
		// 	})
		// }
	},
	destroyed(){
		let _this = this;
		clearInterval(_this.eventInterval)
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-gather-box {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	background: #fff;
	/* border-top: 2px solid #1E1F22; */
  border-top: 1px solid #515151;
}
.z-gather-btn{
	border-radius: 0px;
}

/*新*/
.z-subAccount-item {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
	padding: 10px;
	border-bottom: 1px solid #515151;
}
.z-subAccount-user {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
}
.z-subAccount-info div:nth-child(2) {
	font-size: 10px;
	color: #9B9A9C;
}
.z-icon {
	width: 18px;
	height: 18px;
}

.z-keyOrderDown-Hq-list-th {
	justify-content:space-between;
	padding: 5px 10px;
	color: #7C8086;
	font-size: 12px;
  padding: 10px 10px;
  text-align: center;
}
.z-keyOrderDown-Hq-list-th>div{
	width: 33%;
}
.z-keyOrderDown-Hq-list-item-title{
	color: #7C8086;
	font-size: 16px;
	align-self:flex-start;
	background: #1C2023;
	padding: 5px 10px;
	border-radius: 10px;
}
.z-keyOrderDown-Hq-list-title{
	padding: 10px;
	color: #E2B96F;
	border-bottom: 1px solid #2f2b2b;
}
.z-keyOrderDown-Hq-list {
	flex-direction:column;
  margin-bottom: 30px;
}
.z-keyOrderDown-Hq-list-a{
	width: 100%;
	padding: 10px 10px;
	justify-content:space-between;
	border-bottom: 1px solid #515151;
	text-align: center;
}
.z-keyOrderDown-Hq-list-a div:nth-child(1) {
	text-align: left;
	color: white;
	width: 33%;
}
.z-keyOrderDown-Hq-list-a div:nth-child(2) {
	width: 33%;
	color: #00C087;
}
.z-keyOrderDown-Hq-list-a div:nth-child(3) {
	width: 33%;
	color: white;
	border-radius: 2px;
	font-size: 12px;
}
/* 选择 */
  .z-keyOrderDown-buy-select {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-around;
    border: 1px solid #6B6B6B;
    width: 90%;
    margin: 0 auto;
    padding: 8px 5px;
    border-radius: 5px;
  }

  .z-keyOrderDown-buy-select div:nth-child(1) input {
    width: 60%;
    outline: none;
  }

  .z-keyOrderDown-buy-select div:nth-child(1) {
    border-right: 1px solid #6B6B6B;
    display: flex;
    display: -webkit-flex;
    align-items: center;
  }

  .z-keyOrderDown-buy-select div:nth-child(1) img {
    width: 20px;
    height: 20px;
  }

  .z-keyOrderDown-buy-select div:nth-child(2) {
    text-align: center;
    width: 30%;
  }

  .z-keyOrderDown-buy-select div:nth-child(2) img {
    width: 10px;
    height: 10px;
  }

  .z-keyOrderDown-buy-dialog {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    background: white;
    width: 100%;
    color: #282834;

  }

  .z-keyOrderDown-buy-dialog div {
    padding: 8px;
    width: 80%;
    text-align: center;
  }

  .z-keyOrderDown-buy-dialog img {
    width: 10px;
    height: 10px;
  }

  .z-keyOrderDown-buy-dialog div:nth-child(1),
  .z-keyOrderDown-buy-dialog div:last-child {
    color: #ABABAB;
  }

  .z-keyOrderDown-buy-dialog div:last-child {
    text-align: right;
  }

  .z-buy-model-select {
    color: #E2B96F;
  }
/* 按钮 */
  .z-keyOrderDown-btns {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 10px auto;
  }

  .z-keyOrderDown-btns div {
    width: 46%;
    border-radius: 5px;
    text-align: center;
    padding: 10px;
  }

  .z-keyOrderDown-btns div:nth-child(1) {
    background: #DF0712;
    color: #fff;
  }

  .z-keyOrderDown-btns div:nth-child(2) {
    background: #05D209;
    color: #fff;
  }
.z-keyOrderDown-bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/keyOrderDown.vue